import React from "react";
import "./Unsubscribe.scss";
import {
  TERMS_AND_CONDITIONS_URL,
  CIGNA_URL,
  PRIVACY_POLICY_URL,
} from "../../constants";

const Unsubscribe = () => {
  return (
    <div className="container mt-5">
      <div className="card p-4 shadow">
        <div id="parent-wrapper">
          <div id="wrapper">
            <header id="cigna-header">
              <div className="container">
                <img
                  id="cigna-logo"
                  alt=""
                  src="https://d3ppyoxr8wczcq.cloudfront.net/images/jan2016/cigna-logo.png"
                />
              </div>
            </header>

            <div className="unsub-container container">
              <div className="row">
                <h5>Unsubscribe Successful</h5>
                <h6>
                  You have been successfully unsubscribed from Cigna's dental
                  review emails.
                </h6>
              </div>
            </div>
          </div>
          <div id="footer">
            <div className="container">
              <ul className="list-inline">
                <li>
                  <a href={CIGNA_URL} target="_blank" rel="noopener noreferrer">
                    Cigna
                  </a>
                </li>
                <li className="divider">
                  <span></span>
                </li>
                <li>
                  <a
                    href={TERMS_AND_CONDITIONS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms and Conditions
                  </a>
                </li>
                <li className="divider">
                  <span></span>
                </li>
                <li>
                  <a
                    href={PRIVACY_POLICY_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unsubscribe;
